'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'cube';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1b2';
var svgPathData = ['M32.5 154.5l0 203c0 17.1 9.1 33 24 41.6L232.3 500.6c5 2.9 10.5 4.8 16 5.8l0-245.8-212.8-122.9c-2 5.3-3 10.9-3 16.7zm11-30.6L256.3 246.8 469.2 123.9c-3.6-4.3-8-8.1-13-11L280.3 11.4c-14.9-8.6-33.1-8.6-48 0L56.5 112.9c-5 2.9-9.4 6.6-13 11z', 'M232.3 11.4L56.5 112.9c-5 2.9-9.4 6.6-13 11L256.3 246.8 469.2 123.9c-3.6-4.3-8-8.1-13-11L280.3 11.4c-14.9-8.6-33.1-8.6-48 0zM35.5 137.7c-2 5.3-3 10.9-3 16.7l0 203c0 17.1 9.1 33 24 41.6L232.3 500.6c5 2.9 10.5 4.8 16 5.8l0-245.8-212.8-122.9zM264.3 506.4c5.6-.9 11-2.9 16-5.8L456.2 399.1c14.9-8.6 24-24.4 24-41.6l0-203c0-5.8-1-11.5-3-16.7l-212.8 122.9 0 245.8zM224.3-2.5c19.8-11.4 44.2-11.4 64 0L464.2 99c19.8 11.4 32 32.6 32 55.4l0 203c0 22.9-12.2 44-32 55.4L288.3 514.5c-19.8 11.4-44.2 11.4-64 0L48.5 413c-19.8-11.4-32-32.6-32-55.4l0-203c0-22.9 12.2-44 32-55.4L224.3-2.5z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCube = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;